/**
 * payments.type
 */
export enum PaymentType {
	BANKZAHLUNG = 3, // Bank transfer
	BARZAHLUNG = 4, // Cash
	KARTENZAHLUNG = 5, // Credit card
	DEBITKARTE = 6, // Debit card
	TWINT = 7, // TWINT
	GUTSCHRIFT = 8, // Credit note
}

export const MapPaymentTypeToString = {
	[PaymentType.BANKZAHLUNG]: "Bankzahlung",
	[PaymentType.BARZAHLUNG]: "Barzahlung",
	[PaymentType.KARTENZAHLUNG]: "Kartenzahlung",
	[PaymentType.DEBITKARTE]: "Debitkarte",
	[PaymentType.TWINT]: "TWINT",
	[PaymentType.GUTSCHRIFT]: "Gutschrift",
};
